import React, { useMemo, useState } from 'react';
import { KeyMetricGraphBox } from 'src/components/organisms/KeyMetricGraphBox';
import { TimeseriesDataTableModal } from 'src/components/organisms/TimeseriesDataTableModal';
import { useMergeBenchmarkTimeseries } from 'src/hooks/useMergeBenchmarkTimeseries';
import {
  KeyMetricsDateFormatter,
  ValueTickFormatter,
} from 'src/utils/TickFormatters';
import { cpaDef } from 'src/utils/metricDefinitions';
import { useKpiMetricLabels } from 'src/hooks/useKpiMetricLabels';
import { useDADataContext } from '../../contexts/DADataContext';

const title = 'CPA';

export const CPAOTBox: React.FC = () => {
  const { conversions, benchmarkConversions } = useDADataContext();
  const { metricLabel } = useKpiMetricLabels();
  const { getMergedTimeSeries } = useMergeBenchmarkTimeseries();

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const data = useMemo(() => {
    return getMergedTimeSeries(
      conversions.data,
      benchmarkConversions.data,
      (v) => ({ value: v.measurements.cpa }),
      (v) => ({ benchmark: v.measurements.cpa }),
      false,
      'day',
    );
  }, [conversions, benchmarkConversions, getMergedTimeSeries]);

  return (
    <KeyMetricGraphBox
      title={title}
      legendLabel={title}
      data={data}
      xAxisFormatter={KeyMetricsDateFormatter}
      yAxisFormatter={ValueTickFormatter}
      isError={conversions.isError}
      isLoading={conversions.isLoading}
      infoHeader="Cost per Acquisition"
      infoText={cpaDef(metricLabel)}
      exportEnabled
      onTableModalOpen={setModalIsOpen}
      tableModal={
        <TimeseriesDataTableModal
          isOpen={modalIsOpen}
          setIsOpen={setModalIsOpen}
          yFormatter={ValueTickFormatter}
          dateFormatter={KeyMetricsDateFormatter}
          data={data}
          headerName={title}
        />
      }
    />
  );
};
